import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    item: {},
    items: [],
    itemsTotal: 0,
    memoirStats: [],
  },
  getters: {
    items: state => state.items,
    itemsTotal: state => state.itemsTotal,
    item: state => state.item,
    memoirStats: state => state.memoirStats,
  },
  mutations: {
    SAVE_ITEMS(state, items) {
      state.items = items
    },
    SAVE_ITEM(state, item) {
      state.item = item
    },
    SAVE_ITEMS_TOTAL(state, itemsTotal) {
      state.itemsTotal = itemsTotal
    },
    CLEAR_ITEMS(state) {
      state.items = []
    },
    SAVE_MEMOIR(state, data) {
      state.memoirStats = data
    },
    CLEAR_ITEM(state) {
      state.item = {
        multimedia: [],
        wos_data: [],
        files: [],
        publication_stage: [],
        publication_status: [],
        publication_type: [],
        important_file: {},
        publish: true,
      }
    },
  },
  actions: {
    async fetch({ commit }) {
      try {
        const resp = await Vue.prototype.$http.get(`${Vue.prototype.$groupUrl}/publications`)
        commit('SAVE_ITEMS_TOTAL', resp.data.total)
        commit('SAVE_ITEMS', resp.data.data.data)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    async filter({ commit }, filters) {
      try {
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/publications/filter`, filters)
        commit('SAVE_ITEMS_TOTAL', resp.data.total)
        commit('SAVE_ITEMS', resp.data.data.data)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    async fetchId({ commit }, id) {
      try {
        const resp = await Vue.prototype.$http.get(`${Vue.prototype.$groupUrl}/publications/${id}`)
        commit('SAVE_ITEM', resp.data.data)
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async update({ commit }, publication) {
      try {
        const resp = await Vue.prototype.$http.put(`${Vue.prototype.$groupUrl}/publications/${publication.id}`, publication)
        Vue.prototype.$saveFiles(publication.files_new)
        Vue.prototype.$saveFiles([publication.important_file.data])
        commit('SAVE_ITEM', resp.data.data)
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async create({ commit }, data) {
      try {
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/publications`, data)
        Vue.prototype.$saveFiles(data.files_new)
        Vue.prototype.$saveFiles([data.important_file.data])
        commit('SAVE_ITEM', resp.data.data)
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async getMemoirStats({ commit }, filters) {
      try {
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/publications/get-memoir`, filters)
        commit('SAVE_MEMOIR', resp.data)
      } catch (e) {
        console.log(e)
      }
    },
    cleanType({ commit }) {
      commit('CLEAR_ITEM')
    },
    export({ commit }, filters) {
      try {
        Vue.prototype.$export({
          url: `${Vue.prototype.$groupUrl}/publications/export`,
          filters,
          name: 'researcher',
        })
      } catch (e) {
        console.log(e)
        commit('FETCH_FAILED')
      }
    },
    async applyActions({ commit }, data) {
      try {
        await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/publications/apply-actions`, { actions: data.actions, itemIds: data.itemIds })
      } catch (e) {
        commit('FETCH_FAILED')
        console.log(e)
      }
    },
  },
}
